import React, {useState, useRef } from 'react';
import emailjs from '@emailjs/browser';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { ImLocation }  from 'react-icons/im';
import { FiPhone }  from 'react-icons/fi';
import { SiGmail }  from 'react-icons/si';
import { AiFillGithub }  from 'react-icons/ai';
import { AiFillLinkedin }  from 'react-icons/ai';
import { DiNpm }  from 'react-icons/di';
import { FaResearchgate }  from 'react-icons/fa';
import { FiFacebook }  from 'react-icons/fi';
import { FiTwitter }  from 'react-icons/fi';
import { FiSend }  from 'react-icons/fi';


const ContactInfoModalLayout = () => {
    const [email, setEmail] = useState('')
    const form = useRef();


    const successNotify = () => toast.success('😇 email was successfully sent!', {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        });
    const errorNotify = () =>toast.error('😞 Sorry! Something Went Wrong!', {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        });

    const sendEmail = (e) => {
        e.preventDefault();
    
        emailjs.sendForm('service_8thqfnk', 'template_s4mlf9v', form.current, 'user_SkGSo4bOG1hSEIbpWCjI8')
          .then((result) => {
            //   console.log(result.text);
              if(result.text === 'OK'){
                successNotify()
              }
          }, (error) => {
            errorNotify()
            //   console.log(error.text);
          });
          e.target.reset()
      };
    return(
        <div className="ContactInfoModalLayout-wrapper">
            <section className="left-wrapper">
                <h1>Find me at</h1>
                <div className="socialMediaLink-wrapper">
                    <div className="socialMediaLink">
                       <div className='socialMedia-icon-wrapper  hvr-buzz'><ImLocation className='socialMedia-icon'/></div> 
                        <h5>Address</h5>
                        <a href="https://www.google.com/maps/place/DIT+project+Badda/@23.772222,90.4229138,16z/data=!4m9!1m2!2m1!1sdit+project+merul+badda!3m5!1s0x3755c70cd3d4d2bd:0x634a747c43d45f89!8m2!3d23.7720892!4d90.4276069!15sChdkaXQgcHJvamVjdCBtZXJ1bCBiYWRkYZIBD2hvdXNpbmdfc29jaWV0eQ" rel="noreferrer" target="_blank">DIT, Merul Badda,<br/> Dhaka, Bangladesh</a>
                       
                    </div>
                    <div className="socialMediaLink">
                        <div className='socialMedia-icon-wrapper hvr-buzz'><FiPhone className='socialMedia-icon'/></div> 
                            <h5>Phone</h5>
                            <p>01521107827</p>
                         </div>
                   
                    <div className="socialMediaLink">
                        <div className='socialMedia-icon-wrapper hvr-buzz'><SiGmail className='socialMedia-icon'/></div> 
                            <h5>Gmail</h5>
                            <a href="mailto:omorfarukrakib@gmail.com" rel="noreferrer" target="_blank">omorfarukrakib@gmail.com</a>
                        
                    </div>
                    <div className="socialMediaLink">
                    <div className='socialMedia-icon-wrapper hvr-buzz'><AiFillGithub className='socialMedia-icon'/></div> 
                            <h5>Github</h5>
                            <a href="https://github.com/OmorFarukRakib" rel="noreferrer" target="_blank">OmorFarukRakib</a>
                        
                    </div>
                    <div className="socialMediaLink">
                    <div className='socialMedia-icon-wrapper hvr-buzz'><AiFillLinkedin className='socialMedia-icon'/></div> 
                            <h5>LinkedIn</h5>
                            <a href="https://bd.linkedin.com/in/omorfarukrakib" rel="noreferrer" target="_blank">OmorFarukRakib</a>

                        
                    </div>
                    <div className="socialMediaLink">
                    <div className='socialMedia-icon-wrapper hvr-buzz'><DiNpm className='socialMedia-icon'/></div> 
                            <h5>npm</h5>
                            <a href="https://www.npmjs.com/~ofr" rel="noreferrer" target="_blank">OFR</a>

                        
                    </div>
                    <div className="socialMediaLink">
                    <div className='socialMedia-icon-wrapper hvr-buzz'><FaResearchgate className='socialMedia-icon'/></div> 
                            <h5>ResearchGate</h5>
                            <a href="https://www.researchgate.net/profile/Omor-Rakib" rel="noreferrer" target="_blank">Omor-Rakib</a>
                        
                    </div>
                    
                    <div className="socialMediaLink">
                    <div className='socialMedia-icon-wrapper hvr-buzz'><FiFacebook className='socialMedia-icon'/></div> 
                            <h5>Facebook</h5>
                            <a href="https://www.facebook.com/OmorFarukRakib" rel="noreferrer" target="_blank">OmorFarukRakib</a>

                        
                    </div>
                    <div className="socialMediaLink">
                    <div className='socialMedia-icon-wrapper hvr-buzz'><FiTwitter className='socialMedia-icon'/></div> 
                            <h5>Twitter</h5>
                            <a href="https://twitter.com/Rakib1001" rel="noreferrer" target="_blank">Rakib1001</a>
                    </div>
                </div>

            </section>
            <section className="right-wrapper">
                <ToastContainer
                position="bottom-left"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                />
            <h1>Wanna say hello? </h1>
            <h3>I would love to hear from you! </h3>
            <form ref={form} onSubmit={sendEmail}>      
                <input name="from_name" type="text" className="feedback-input" placeholder="Name" />   
                <input name="email" type="text" required className="feedback-input" placeholder="Email" onChange={(e) => setEmail(e.target.value)} />
                <input name="phone_num" type="number" className="feedback-input" placeholder="Phone number" />
                <input name="subject" type="text" className="feedback-input" placeholder="Subject" />
                <textarea name="message" className="feedback-input" placeholder="Message"></textarea>
                <input name="reply_to" type="text" className="feedback-input" hidden value={email} />
                {/* <input type="submit" value="SUBMIT"/> */}
                <button className='submit-btn'><FiSend/></button>
            </form>

            </section>
        </div>
    )
}


export default ContactInfoModalLayout;